document.addEventListener('DOMContentLoaded', () => {
  headerAnimation()
  showSwiper()
})

const headerAnimation = function () {
  const mainnavigation = document.getElementById('mainnavigation')
  const siteheader = document.getElementById('siteheader')
  const downloadbutton = document.getElementById('download-button')
  var lastScrollTop = 0
  document.addEventListener('scroll', () => {
    if (window.scrollY > 150) {
      siteheader.classList.add('siteheader-collapsed')
    } else {
      siteheader.classList.remove('siteheader-collapsed')
    }

    if (window.scrollY > 280) {
      siteheader.classList.add('siteheader-collapsed-translate')
    } else {
      siteheader.classList.remove('siteheader-collapsed-translate')
    }

    if (window.scrollY > 400) {
      if (downloadbutton) {
        downloadbutton.classList.add('download-button-collapsed')
      }
    } else {
      if (downloadbutton) {
        downloadbutton.classList.remove('download-button-collapsed')
      }
    }

    var st = window.pageYOffset || document.documentElement.scrollTop
    const body = document.body

    if (st > lastScrollTop) {
      body.classList.add('hide-header')

      if (mainnavigation.classList.contains('show')) {
        siteheader.classList.add('site-header-is-open')
      }
    } else {
      body.classList.remove('hide-header')
    }
    lastScrollTop = st <= 0 ? 0 : st
  })
}

const showSwiper = function () {
  const tables = document.querySelectorAll('.table[style]:not([style=""])')


  tables.forEach(table => {
    let swipeIcon = document.createElement("img")
    swipeIcon.setAttribute('src', '/_assets/12ecccfe9186b84b10b2cda53d4b5e65/Images/icon-swipe-horizontal.svg')
    swipeIcon.setAttribute('width', '200')
    swipeIcon.setAttribute('height', '200')
    swipeIcon.setAttribute('class', 'swipe-icon')
    table.parentElement.append(swipeIcon)

    const observer = new IntersectionObserver((entries) => {
      if(entries[0].isIntersecting){
        table.parentElement.classList.add('start-animation')
      } else {
        table.parentElement.classList.remove('start-animation')
      }
    })
    observer.observe(table)
  })
}
